module.exports = __webpack_public_path__ + "static/media/home_medical_certificate_icon.b5581eb1.png";